import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { companyTabs } from '../../data/services';
export function Companies() {
  const [active, setActive] = useState(companyTabs[0].id);
  const current = companyTabs.find(t => t.id === active) ?? companyTabs[0];
  return <section id="companias" className="bg-cream py-20 lg:py-32" data-id="element-76" data-mp="312pjo2mul352">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-77" data-mp="314ai43ca9687">
        <SectionHeader eyebrow="Compañías" align="center" title="Trabajo con diferentes compañías." subtitle="Esto permite explorar diferentes alternativas dependiendo del producto, estado, elegibilidad y necesidades del cliente." data-id="element-78" data-mp="2wbhddfgtdxw4" />

        <Reveal className="mt-12 flex justify-center" data-id="element-79" data-mp="2ibyfdfhpw2xj">
          <div role="tablist" aria-label="Categorías de compañías" className="inline-flex flex-wrap justify-center gap-1 rounded-full border border-navy/[0.08] bg-white p-1.5" data-id="element-80" data-mp="2ibpy7bekabgj">
            {companyTabs.map(tab => <button key={tab.id} role="tab" type="button" aria-selected={active === tab.id} onClick={() => setActive(tab.id)} className={`relative rounded-full px-6 py-2.5 font-display text-[11.5px] font-semibold tracking-[0.12em] transition-colors duration-200 ease-out ${active === tab.id ? 'text-white' : 'text-ink/60 hover:text-teal'}`} data-id="element-81" data-mp="f13k2krldqtc">
                {active === tab.id && <motion.span layoutId="company-tab" className="absolute inset-0 rounded-full bg-teal" transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-82" data-mp="j271hbpafuwo" />}
                <span className="relative" data-id="element-83" data-mp="38s0ydj6jsjhp">{tab.label}</span>
              </button>)}
          </div>
        </Reveal>

        <motion.ul key={current.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 lg:gap-4" data-id="element-84" data-mp="1f8ihb9mg7umg">
          {current.companies.map(name => <li key={name} className="flex min-h-[86px] items-center justify-center rounded-[16px] border border-navy/[0.08] bg-white px-4 py-5 text-center font-display text-[13px] font-medium text-navy/80 transition-[border-color,color] duration-200 ease-out hover:border-teal/30 hover:text-teal" data-id="element-85" data-mp="vl2p9hpczfw4">
              {name}
            </li>)}
        </motion.ul>

        <p className="mx-auto mt-10 max-w-3xl text-center text-[12.5px] font-light leading-relaxed text-ink/50" data-id="element-86" data-mp="2gy5jbi2nbrck">
          Las compañías, productos y opciones disponibles pueden variar según el estado,
          licencia, elegibilidad, disponibilidad del producto y necesidades individuales.
        </p>
      </div>
    </section>;
}